import React, { useEffect } from "react";
import { UI_CAPTION } from "oolib";
import { ButtonGhost } from "oolib/dist/v2/components/Buttons";

import { useSankeyConfig } from "./ConfigForm_Context";
import { ConfigForm_SectionWrapper } from "../../WidgetMetricCard/ConfigForm/ConfigForm_SectionWrapper";
import { ReportsLightboxInput } from "../../WidgetBarChart/WIDGET_ELEM_ConfigForm";
import { ArithmeticExpressionInput } from "../../utils/ArithmeticExpressionInput";
import { getPickerProp } from "../../utils/pickerVariantConfig";
import Draggable from "@/components/generalUI/Draggable";

export const ConfigForm_DimensionsSection = () => {
  const {
    dimensions,
    firstDim,
    dim1Options,
    subsequentDimOptions,
    handleDimChange,
    handleAddDimension,
    handleRemoveDimension,
    handleReorderDimensions,
  } = useSankeyConfig();

  // Seed with one empty dimension slot if none exist
  useEffect(() => {
    if (dimensions.length === 0) {
      handleAddDimension();
    }
  }, []);

  const addButton = (
    <ButtonGhost
      icon="Plus"
      onClick={handleAddDimension}
    />
  );

  return (
    <ConfigForm_SectionWrapper icon="FlowArrow" title="Steps" headerRight={addButton}>

      {dimensions.length === 0 && (
        <UI_CAPTION>Click + to add steps</UI_CAPTION>
      )}

      <Draggable
        ary={dimensions}
        idValPath="_id"
        enableDraggableHandle={true}
        handleReposition={handleReorderDimensions}
        style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}
        renderChildren={(dim, index) => (
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '0.5rem' }}>
            <div style={{ flex: 1 }}>
              {index === 0 ? (
                <ArithmeticExpressionInput
                  id={`sankey-dim-${index}`}
                  label={`Step ${index + 1}`}
                  allOptions={dim1Options}
                  value={dim.display ? dim : undefined}
                  onChange={(v) => handleDimChange(index, v)}
                  picker={getPickerProp({ widgetComp: 'WidgetSankeyChart', slot: 'step0' })}
                />
              ) : (
                <ReportsLightboxInput
                  id={`sankey-dim-${index}`}
                  label={`Step ${index + 1}`}
                  placeholder="Select step"
                  disabled={!firstDim}
                  options={subsequentDimOptions}
                  value={dim.display ? dim : undefined}
                  onChange={(_, v) => handleDimChange(index, v)}
                  picker={getPickerProp({ widgetComp: 'WidgetSankeyChart', slot: 'steps' })}
                />
              )}
            </div>
            <ButtonGhost
              icon="X"
              onClick={() => handleRemoveDimension(index)}
              style={{ marginBottom: '2px' }}
            />
          </div>
        )}
      />

    </ConfigForm_SectionWrapper>
  );
};
